import { render, staticRenderFns } from "./UserUsergroupTableActions.vue?vue&type=template&id=2da74802&"
import script from "./UserUsergroupTableActions.vue?vue&type=script&lang=js&"
export * from "./UserUsergroupTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports